import { render, staticRenderFns } from "./gj-checkbox-group.vue?vue&type=template&id=2b94c3f6&scoped=true&"
import script from "./gj-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./gj-checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94c3f6",
  null
  
)

export default component.exports